import BecomeAMemberNow from './BecomeAMemberNow';

export default BecomeAMemberNow;